import { fireFocusByYearType } from 'store/typesActions/types';

const initialState = {
	fireYear: [],
	isLoading: false,
	error: false,
	message: ''
};

export default function fireFocusByMonthReducer(state = initialState, action) {
	const { errors } = action?.payload || { errors: {} };

	switch (action.type) {
		case fireFocusByYearType.FIRE_FOCUS_BY_YEAR:
			return {
				...state,
				isLoading: true,
				error: false,
				message: 'Buscando dados do desmatamento'
			};

		case fireFocusByYearType.FIRE_FOCUS_BY_YEAR_SUCCESS:
			return {
				fireYear: action.payload,
				isLoading: false,
				error: false,
				message: ''
			};

		case fireFocusByYearType.FIRE_FOCUS_BY_YEAR_ERROR:
			return {
				...state,
				fireYear: [],
				isReq: false,
				error: true,
				message: 'Erro ao buscar por dados, tente novamente mais tarde'
			};
		default:
			return state;
	}
}
